import { useEffect, useMemo, useState } from 'react';
import { useAuthContext } from "../auth/LauncherAuthContext";
import { HomeOutlined, ProfileOutlined, RocketOutlined, ScheduleOutlined, CompassOutlined } from "@ant-design/icons";
import { D20 } from '../../commons/icons/d20';

export interface MenuLink {
    link: string;
    icon: JSX.Element;
    text: string;
}

export const useMyMenu = () => {
    const { user, isAdmin, isUserLoggedIn } = useAuthContext();
    const [menuLinks, setMenuLinks] = useState<MenuLink[]>([]);
    const isOrganizer = useMemo(() => !!user?.organizer, [user]);

    useEffect(() => {
        const links: MenuLink[] = [];

        links.push({
            link: '/',
            icon: <HomeOutlined />,
            text: 'home',
        });

        links.push({
            link: '/invitations',
            icon: <CompassOutlined />,
            text: 'play',
        });

        if (isAdmin()) {
            links.push({
                link: '/admin',
                icon: <RocketOutlined />,
                text: 'admin',
            });
        }

        if (isOrganizer) {
            links.push({
                link: '/organizer',
                icon: <D20 />,
                text: 'GM',
            });
        }


        if (isUserLoggedIn()) {
            links.push({
                link: '/profile',
                icon: <ProfileOutlined />,
                text: 'profile'
            });
            links.push({
                link: '/my-reservations',
                icon: <ScheduleOutlined />,
                text: 'resv',
            });
        }
        setMenuLinks(links);
    }, [user?.id, user?.organizer, isAdmin, isUserLoggedIn, isOrganizer]);

    return menuLinks;
}